import baseService from './apiService';
import { Get_Token } from 'resolvers/Get_Token';

export async function bankAuth(data) {
    const response = await baseService.post('/banks/auth', data);
    return response.data;
}

export async function bankResolveMFA(data) {
    const response = await baseService.post('/banks/auth/mfa', data);
    return response.data;
}

export async function bankLinking(data) {
    const response = await baseService.post('banks/auth/link', data);
    return response.data;
}

export async function createBank(data) {
    const response = await baseService.post('banks', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getTheBanks() {
    const response = await baseService.get('/banks/', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getBankNode(id, refresh = false) {
    const token = Get_Token();
    const response = await baseService.get(`/banks/${id}`, {
        params: {
            refresh: refresh
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export async function relinkBank(id) {
    const response = await baseService.post(
        `/banks/${id}/relink`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function makePrimary(id) {
    const response = await baseService.post(
        `/banks/${id}/primary`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function apiDeleteBankAccount(id) {
    const response = await baseService.delete(`/banks/${id}`, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getIntegrationKey() {
    const response = await baseService.post(
        '/banks/sophtron/auth/token',
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function getIntregrationStatus(data) {
    const response = await baseService.post('/banks/sophtron/status', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function reconnectSophtron(id) {
    const response = await baseService.post(
        `/banks/sophtron/${id}/reauth/token`,
        {},
        {
            headers: {
                Authorization: `Bearer ${Get_Token()}`
            }
        }
    );
    return response.data;
}

export async function postAccountLinking(data) {
    const response = await baseService.post('/banks/sophtron/link', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function postAccountRelinking(data) {
    const response = await baseService.post('/banks/sophtron/relink', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function deleteBankLinking(data) {
    const response = await baseService.delete('/banks/sophtron/pending', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function getBankLinking(data) {
    const response = await baseService.get('/banks/sophtron/pending', {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}

export async function postSophtronEvent(data) {
    const response = await baseService.post('/banks/sophtron/event', data, {
        headers: {
            Authorization: `Bearer ${Get_Token()}`
        }
    });
    return response.data;
}
